module.exports = __webpack_public_path__ + "static/mentor-748c250853b7091a0679bd8a085db4c7.jpg";